"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosThemeForegroundSchema = exports.APosThemeBackgroundSchema = exports.APosThemeImageSchema = exports.APosThemeImageFitSchema = exports.APosThemeSolidSchema = exports.APosThemeGradientSchema = exports.APosThemeGradientStopSchema = void 0;
const zod_1 = require("zod");
const HexColor = zod_1.z.string().regex(/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/, 'Must be a #hex color');
exports.APosThemeGradientStopSchema = zod_1.z.object({
    color: HexColor,
    position: zod_1.z.number().min(0).max(100),
});
exports.APosThemeGradientSchema = zod_1.z.object({
    type: zod_1.z.literal('gradient'),
    angle: zod_1.z.number().min(0).max(360),
    stops: zod_1.z.array(exports.APosThemeGradientStopSchema).min(2).max(8),
});
exports.APosThemeSolidSchema = zod_1.z.object({
    type: zod_1.z.literal('solid'),
    color: HexColor,
});
exports.APosThemeImageFitSchema = zod_1.z.enum(['cover', 'contain', 'center']);
exports.APosThemeImageSchema = zod_1.z.object({
    type: zod_1.z.literal('image'),
    url: zod_1.z.string().url(),
    fit: exports.APosThemeImageFitSchema.default('cover'),
    // 0..80 — darken overlay applied above the image so light text stays readable.
    overlay: zod_1.z.number().min(0).max(80).default(40),
});
exports.APosThemeBackgroundSchema = zod_1.z.discriminatedUnion('type', [
    exports.APosThemeGradientSchema,
    exports.APosThemeSolidSchema,
    exports.APosThemeImageSchema,
]);
exports.APosThemeForegroundSchema = zod_1.z.object({
    enabled: zod_1.z.boolean().default(false),
    url: zod_1.z.string().url().optional(),
    scale: zod_1.z.number().min(10).max(100).default(40),
});
//# sourceMappingURL=background.schema.js.map